module.exports = __webpack_public_path__ + "static/undraw_world_9iqb-4bfa1d8ea3f8579043f6a3fba26d1035.svg";